var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"scanner-button"},[_c('BaseElButton',{attrs:{"type":"text"},on:{"click":function($event){_vm.dialogVisible = true}}},[_c('SVGIcon',{attrs:{"icon":"common-scanner_gun"}})],1),(_vm.dialogVisible)?_c('ScannerDialog',{on:{"close":function($event){_vm.dialogVisible = false}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }